import { css, styled } from "styled-components";
import { theme } from "@local-logic/core/ui";

interface SearchProps {
  $renderListAbove?: boolean;
  $renderListAbovePosition?: number;
}

export const Search = styled.div`
  flex: 1;
  position: relative;
`;

export const SearchList = styled.div<SearchProps>`
  position: absolute;
  top: calc(100% + 6px);
  width: 100%;
  box-shadow: 0px 5px 8px -4px rgba(0, 0, 0, 0.5);
  transform: translateY(-3px);
  background-color: ${theme["--ll-color-background"]};
  border-radius: ${theme["--ll-border-radius-small"]};
  z-index: 3;

  ${({ $renderListAbove, $renderListAbovePosition }) =>
    $renderListAbove &&
    css`
      top: inherit;
      bottom: ${$renderListAbovePosition}px;
    `}
`;

export const ItemButton = styled.button`
  width: 100%;
  border: none;
  cursor: pointer;
  text-align: left;
  padding: ${theme["--ll-spacing-medium"]} ${theme["--ll-spacing-small"]};
  background-color: var(--color-white);
  margin: 0;

  &:focus {
    transform: translate3d(0, 0, 0);
  }
`;

export const SearchListUl = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0;
`;

export const SearchListItem = styled.li`
  &:last-child {
    ${ItemButton} {
      overflow: hidden;
      border-radius: 0 0 ${theme["--ll-border-radius-small"]}
        ${theme["--ll-border-radius-small"]};
    }
  }

  &:hover {
    background-color: ${theme["--ll-color-surface"]};
  }
`;
